import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

import { Markdown } from '../../components/utils';

import styles from './teaser.module.scss';

export const Teaser = ({ data }) => (
	<div className={styles.wrapper}>
		<div className={styles.container}>
			<div className={styles.holder}>
				<div className={styles.content}>
					<Markdown content={data.content} />
					<Link to={data.link.url} className={styles.button}>
						{data.link.label}
					</Link>
				</div>

				{data.video.url && (
					<div className={styles.video}>
						<iframe
							allowFullScreen={true}
							className={styles.iframe}
							title={data.video.title}
							allow="accelerometer; encrypted-media; gyroscope; modestbranding; autoplay; picture-in-picture"
							src={`${data.video.url}?autoplay=0&amp;showinfo=0&amp;controls=0&amp;rel=0&amp;modestbranding`}></iframe>
					</div>
				)}
			</div>
		</div>
	</div>
);

Teaser.defaultProps = {
	data: {},
};

Teaser.propTypes = {
	data: PropTypes.object.isRequired,
};
